// Does string contain letters?
export const hasCapitalLetter = function (string) {
  return string.match(/[A-Z]/);
};

export const hasLowerLetter = function (string) {
  return string.match(/[a-z]/);
};

// Does string contain numbers?
export const hasNumber = function (string) {
  return string.match(/\d/);
};

// Does string contain special characters?
export const hasSpecialCharacter = function (string) {
  return string.match(/[^a-zA-Z\d]/);
};
